import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
	templateUrl: './container.component.html'
})

export class ContainerComponent implements OnInit {

	component: string;

	constructor(private activatedroute: ActivatedRoute) {}

	ngOnInit() {
		this.activatedroute.data.subscribe(data => {
			if (data.component) {
				this.component = data.component;
			}
		});
	}
}
